import { MessageService } from '../layout/message/message.service';
import { Router } from '@angular/router';
import { productWatchService } from '../products/products.service';
import { stringify } from 'querystring';
import { isString } from 'util';

export class BaseComponent {
	// Provided Services
	public _router: Router;
	// Pay Services

	public messageService: MessageService;

	constructor(r: Router, messageService: MessageService, commonHeader: boolean = true) {
		this.messageService = messageService;
		this._router = r;

		if (commonHeader) {
			productWatchService.changeProductImage('default.png');
			productWatchService.changeProductTitle('SJCOE');
		}
	}

	public showSuccessMessage(title?: string, message?: string) {
		this.messageService.createMessage(
			{
				severity: 'success',
				summary: title,
				detail: message,
			},
			false,
		);
	}
	public showInfoMessage(title?: string, message?: string) {
		this.messageService.createMessage(
			{
				severity: 'info',
				summary: title,
				detail: message,
			},
			false,
		);
	}
	public showErrorMessage(title?: string, message?: any) {
		let msg = '';
		if (isString(message)) {
			msg = message.toString();
		} else if (message != null && message.status != null) {
			msg = message.status === 0 ? 'Server Unresponsive. Please try again later.' : stringify(message);
		}

		this.messageService.createMessage(
			{
				severity: 'error',
				summary: title,
				detail: msg,
			},
			true,
		);
	}
	public serverErrorHandler(err: any) {
		this.showErrorMessage('Error', err.message);
	}
}
